import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ArrowLeftIcon } from "lucide-react";
import type { FC } from "react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddItemCategoryList } from "web_myplann/Portfolio/Components/PortfolioAddItemCategoryList";
import { useNavigatePortfolioAddItem } from "web_myplann/Portfolio/Hooks/useNavigatePortfolioAddItem";
import { PORTFOLIO_ADD_ITEM_SECTIONS } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";
import { RedesignListBackground } from "web_myplann/Shared/Components/Redesign/RedesignListBackground";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { useGoBack } from "web_myplann/Shared/Hooks/useGoBack";

export const PortfolioAddItemPage: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigatePortfolioAddItem = useNavigatePortfolioAddItem();
	const navigateBack = useGoBack(Routing.Portfolio.PortfolioList.path());

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBarBgColor={theme.palette.background.paper}
			topBar={
				<Stack
					sx={{
						width: "100%",
						bgcolor: theme.palette.background.paper,
					}}
				>
					<MyPlannTopBarRedesign
						title={t(Resources.Portfolio.AddItem.title)}
						startComponent={
							<IconButton onClick={navigateBack}>
								<ArrowLeftIcon
									size={theme.iconSize.md}
									color={theme.palette.grey[600]}
								/>
							</IconButton>
						}
					/>
				</Stack>
			}
		>
			<RedesignListBackground>
				{PORTFOLIO_ADD_ITEM_SECTIONS.map((section) => (
					<Stack key={section.id}>
						<Typography variant="sectionLabel">
							{t(section.labelKey)}
						</Typography>
						<PortfolioAddItemCategoryList
							items={section.items}
							onItemClick={navigatePortfolioAddItem}
						/>
					</Stack>
				))}
			</RedesignListBackground>
		</MyPlannLayout>
	);
};
